import React from "react";
import { useDispatch, useSelector } from "react-redux";
import useSaveVisualization from "../../../../hooks/useSaveVisualization";
import { Button } from "react-bootstrap";
import useCurrentLocation from "../../../../hooks/useCurrentLocation";
import useTemplateServiceParams from "../../../../hooks/useTemplateServiceParams";

export default function TemplateAction() {
  const { lang, locale } = useSelector((state) => ({
    lang: state.changeLang.language.stepThree.generator,
    locale: state.changeLang.change,
  }));

  const dispatch = useDispatch();
  const { saveTemplateVisualisation } = useSaveVisualization();
  const { isTemplateService } = useCurrentLocation();
  const { applyTemplateUrl } = useTemplateServiceParams();

  const saveTemplate = async () => {
    if (isTemplateService) {
      await saveTemplateVisualisation(applyTemplateUrl);
      dispatch(setIsTemplateApplystate(true));
    }
    await saveTemplateVisualisation();
    window.location.href = `${window.location.origin}${
      locale === "en" ? "" : `/${locale}`
    }/csv-import/`;
  };

  return (
    <section className="bg-white p-3 p-md-4 mt-3 mt-md-4 d-none d-lg-flex justify-content-center rounded-1">
      <Button
        variant="primary"
        className="text-capitalize text-nowrap py-2 px-4 fw-bold"
        onClick={saveTemplate}
      >
        {lang[9]}
      </Button>
    </section>
  );
}
